import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16ec7a84")

_pushScopeId("data-v-16ec7a84")
const _hoisted_1 = { class: "team4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "mb-4 d-flex justify-content-center" }, [
  /*#__PURE__*/_createVNode("header", { class: "widget-header" }, [
    /*#__PURE__*/_createVNode("span", { class: "header-text" }, "The team")
  ])
], -1)
const _hoisted_3 = { class: "d-flex row justify-content-center" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "d-flex justify-content-center text-center" }
const _hoisted_7 = { class: "pt-2" }
const _hoisted_8 = { class: "mt-4 font-weight-medium mb-0" }
const _hoisted_9 = { class: "subtitle mb-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member) => {
        return (_openBlock(), _createBlock("div", {
          class: "col-12 col-lg-2",
          key: member.name
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: _ctx.getImgUrl(member.image),
                class: "img-fluid rounded-circle"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("h5", _hoisted_8, _toDisplayString(member.name), 1),
                _createVNode("h6", _hoisted_9, _toDisplayString(member.title), 1)
              ])
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})